import React, { useEffect, useState } from 'react';
import { api } from '../api';

export default function DetailTypesPage() {
  const auth = JSON.parse(localStorage.getItem("auth") || "{}");
  const isAdmin = auth?.role === 'ADMIN';

  const BELONGS_TO_VALUES = ['максим', 'станок', 'ЗИП'];

  const [types, setTypes] = useState([]);
  const [selectedBelongsTo, setSelectedBelongsTo] = useState('максим');
  const [expandedTypeId, setExpandedTypeId] = useState(null);
  const [editingType, setEditingType] = useState(null);
  const [editingSubtype, setEditingSubtype] = useState(null);
  const [newType, setNewType] = useState({ name: '', description: '' });
  const [newSubtype, setNewSubtype] = useState({ name: '', description: '' });

  const fetchTypes = async () => {
    const res = await api.get('/detail-types');
    setTypes(res.data);
  };

  useEffect(() => {
    fetchTypes();
  }, []);

  const filteredTypes = types.filter((t) => t.belongsTo === selectedBelongsTo);

  const handleCreateType = async () => {
    await api.post('/detail-types', { ...newType, belongsTo: selectedBelongsTo });
    setNewType({ name: '', description: '' });
    fetchTypes();
  };

  const handleUpdateType = async () => {
    await api.put(`/detail-types/${editingType.id}`, editingType);
    setEditingType(null);
    fetchTypes();
  };

  const handleAddSubtype = async (typeId) => {
    await api.post('/detail-subtypes', {
      ...newSubtype,
      type: { id: typeId },
    });
    setNewSubtype({ name: '', description: '' });
    fetchTypes();
  };

  const handleUpdateSubtype = async () => {
    await api.put(`/detail-subtypes/${editingSubtype.id}`, editingSubtype);
    setEditingSubtype(null);
    fetchTypes();
  };

  const handleDeleteSubtype = async (id) => {
    try {
      await api.delete(`/detail-subtypes/${id}`);
      fetchTypes();
    } catch (error) {
      alert("Ошибка удаления: " + (error.response?.data?.message || 'неизвестная ошибка'));
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white p-6 max-w-3xl mx-auto">
      <h1 className="text-2xl mb-4">Типы и разновидности</h1>

      <div className="flex flex-wrap gap-2 mb-6">
        {BELONGS_TO_VALUES.map((value) => (
          <button
            key={value}
            onClick={() => { setSelectedBelongsTo(value); setExpandedTypeId(null); }}
            className={`px-4 py-2 rounded ${
              selectedBelongsTo === value ? 'bg-blue-600' : 'bg-gray-700 hover:bg-gray-600'
            }`}
          >
            {value}
          </button>
        ))}
      </div>

      {filteredTypes.map((type) => (
        <div key={type.id} className="bg-gray-800 rounded p-4 mb-4 border border-gray-700">
          <div className="flex justify-between items-center">
            <div>
              <h3 className="text-lg font-semibold">{type.name}</h3>
              <p className="text-sm text-gray-400">{type.description}</p>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => setExpandedTypeId(expandedTypeId === type.id ? null : type.id)}
                className="bg-blue-600 hover:bg-blue-700 px-3 py-1 rounded"
              >
                {expandedTypeId === type.id ? 'Скрыть' : 'Разновидности'}
              </button>
              {isAdmin && (
                <button
                  onClick={() => setEditingType({ ...type })}
                  className="bg-yellow-600 hover:bg-yellow-700 px-3 py-1 rounded"
                >
                  ✎
                </button>
              )}
            </div>
          </div>

          {expandedTypeId === type.id && (
            <div className="mt-4">
              {(type.subtypes || []).map((sub) => (
                <div key={sub.id} className="bg-gray-700 rounded p-3 mb-2 flex justify-between items-center">
                  <div>
                    <strong>{sub.name}</strong>
                    <p className="text-sm text-gray-300">{sub.description || '—'}</p>
                  </div>
                  {isAdmin && (
                    <div className="flex gap-2">
                      <button
                        onClick={() => setEditingSubtype({ ...sub })}
                        className="bg-yellow-600 hover:bg-yellow-700 px-2 py-1 rounded"
                      >
                        ✎
                      </button>
                      <button
                        onClick={() => handleDeleteSubtype(sub.id)}
                        className="bg-red-600 hover:bg-red-700 px-2 py-1 rounded"
                      >
                        🗑
                      </button>
                    </div>
                  )}
                </div>
              ))}

              {isAdmin && (
                <div className="mt-4">
                  <h4 className="font-semibold mb-1">Добавить разновидность</h4>
                  <input
                    value={newSubtype.name}
                    onChange={(e) => setNewSubtype({ ...newSubtype, name: e.target.value })}
                    placeholder="Название"
                    className="w-full mb-2 p-2 bg-gray-800 rounded"
                  />
                  <textarea
                    value={newSubtype.description}
                    onChange={(e) => setNewSubtype({ ...newSubtype, description: e.target.value })}
                    placeholder="Описание"
                    className="w-full mb-2 p-2 bg-gray-800 rounded"
                  />
                  <button
                    onClick={() => handleAddSubtype(type.id)}
                    className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded"
                  >
                    Добавить разновидность
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      ))}

      {isAdmin && (
        <div className="mt-8">
          <h3 className="mb-2 font-bold text-lg">Добавить новый тип</h3>
          <input
            value={newType.name}
            onChange={(e) => setNewType({ ...newType, name: e.target.value })}
            placeholder="Название типа"
            className="w-full mb-2 p-2 bg-gray-800 rounded"
          />
          <textarea
            value={newType.description}
            onChange={(e) => setNewType({ ...newType, description: e.target.value })}
            placeholder="Описание типа"
            className="w-full mb-2 p-2 bg-gray-800 rounded"
          />
          <button
            onClick={handleCreateType}
            className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded"
          >
            Добавить тип
          </button>
        </div>
      )}

      {editingType && isAdmin && (
        <div className="mt-8">
          <h3 className="mb-2">Редактировать тип</h3>
          <input
            value={editingType.name}
            onChange={(e) => setEditingType({ ...editingType, name: e.target.value })}
            className="w-full mb-2 p-2 bg-gray-800 rounded"
          />
          <textarea
            value={editingType.description}
            onChange={(e) => setEditingType({ ...editingType, description: e.target.value })}
            className="w-full mb-2 p-2 bg-gray-800 rounded"
          />
          <button onClick={handleUpdateType} className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded mr-2">Сохранить</button>
          <button onClick={() => setEditingType(null)} className="bg-gray-600 hover:bg-gray-700 px-4 py-2 rounded">Отмена</button>
        </div>
      )}

      {editingSubtype && isAdmin && (
        <div className="mt-8">
          <h3 className="mb-2">Редактировать разновидность</h3>
          <input
            value={editingSubtype.name}
            onChange={(e) => setEditingSubtype({ ...editingSubtype, name: e.target.value })}
            className="w-full mb-2 p-2 bg-gray-800 rounded"
          />
          <textarea
            value={editingSubtype.description}
            onChange={(e) => setEditingSubtype({ ...editingSubtype, description: e.target.value })}
            className="w-full mb-2 p-2 bg-gray-800 rounded"
          />
          <button onClick={handleUpdateSubtype} className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded mr-2">Сохранить</button>
          <button onClick={() => setEditingSubtype(null)} className="bg-gray-600 hover:bg-gray-700 px-4 py-2 rounded">Отмена</button>
        </div>
      )}
    </div>
  );
}
